import { useEffect, useState } from "react";
import { SignInHeader } from "../components/Auth/SignInHeader/SignInHeader";
import { SignInFooter } from "../components/Auth/SignInFooter/SignInFooter";
import * as Sentry from "@sentry/browser";

import { Authenticator, useAuthenticator } from "@aws-amplify/ui-react";
import { authenticatorServices } from "../utils/authenticatorServices";
import { CompanyOwner } from "../types/schema";
import { authClient } from '../utils/amplifyClient';
import { updateCompanyOwner as updateCompanyOwnerMutation } from "../graphql/mutations";
import { AuthUser, fetchUserAttributes, getCurrentUser } from "aws-amplify/auth";
import { useParams } from "react-router-dom";
import { getCompanyOwner as getCompanyOwnerQuery } from "../graphql/queries";
import { LoadingSpinner } from "../components/LoadingSpinner";
import { NotFound } from "./NotFound";

import "../css/RegistrationPages.css"
import { SignUpHeaderSuperAdminRegistration } from "../components/Auth/SignUpHeader/SignUpHeader";
import TotalEquipIQLogoStacked from "../components/ui/icons-logos/TotalEquipIQLogoStacked";

export const SuperAdminRegister = () => {
    const { user, route } = useAuthenticator((context) => [
        context.route,
    ]);
    const { userIdFromParams } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [companyOwnerNotFound, setCompanyOwnerNotFound] = useState(false);
    const [companyOwnerFromId, setCompanyOwnerFromId] = useState<CompanyOwner | null>(null);
    // const location = useLocation();
    const { toForgotPassword } = useAuthenticator();

    useEffect(() => {
        const getUserFromId = async () => {
            try {
                const result = await authClient.graphql({
                    query: getCompanyOwnerQuery,
                    variables: { id: userIdFromParams as string },
                    authMode: "apiKey",
                });
                setIsLoading(false);
                if (!result.data.getCompanyOwner) {
                    return setCompanyOwnerNotFound(true);
                }
                setCompanyOwnerFromId(result.data.getCompanyOwner as CompanyOwner);
            } catch (error) {
                console.log("error", error);
                Sentry.captureException(error);
            }
        };
        if (!companyOwnerFromId && userIdFromParams) {
            getUserFromId();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
        const updateCompanyOwnerWithCognitoId = async (currentUser: AuthUser) => {
            try {
                const attributes = await fetchUserAttributes();

                // Re-fetch to get latest state
                const result = await authClient.graphql({
                    query: getCompanyOwnerQuery,
                    variables: { id: userIdFromParams as string },
                    authMode: "apiKey",
                });
                const freshOwner = result.data.getCompanyOwner;

                if (!freshOwner) {
                    return setCompanyOwnerNotFound(true);
                }

                // Case 1: No cognitoId — link this account
                if (!freshOwner.cognitoId) {
                    const input = {
                        id: userIdFromParams as string,
                        cognitoId: currentUser.userId,
                        name: attributes.name || freshOwner.name,
                    };
                    await authClient.graphql({
                        query: updateCompanyOwnerMutation,
                        variables: { input },
                        authMode: "userPool",
                    });
                    window.location.href = "/";
                    return;
                }

                // Case 2: Already linked to this user — just redirect
                if (freshOwner.cognitoId === currentUser.userId) {
                    window.location.href = "/";
                    return;
                }

                // Case 3: Linked to someone else
                setCompanyOwnerNotFound(true);
            } catch (error) {
                console.log("error fetching user attributes", error);
                Sentry.captureException(error);
            }
        };
        const getNewUser = async () => {
            const newUser = await getCurrentUser();
            updateCompanyOwnerWithCognitoId(newUser);
        };
        if (route === "authenticated") {
            getNewUser();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [route, companyOwnerFromId, user]);



    const components = {
        SignIn: {
            Header() {
                return <SignInHeader />;
            },
            Footer() {
                return (
                    <SignInFooter
                        toForgotPassword={toForgotPassword}
                        forgotPasswordText="Forgot Password"
                    />
                );
            },
        },
        SignUp: {
            Header() {
                return <SignUpHeaderSuperAdminRegistration />;
            },
        },
    };
    const formFields = {
        signUp: {
            name: {
                placeholder: "Enter Your Name Here",
                isRequired: true,
                label: "Name:",
            },
        },
    }
        ;
    return (
        <LoadingSpinner
            content={companyOwnerNotFound ? (<NotFound />) : (
                <>
                    <div className="fixed-logo">
                        <TotalEquipIQLogoStacked iconClasses="fixed-logo-mark" ariaLabel="TotalEquipIQ" />
                    </div>
                    <div className="auth-wrapper-register">
                        <div className=" centered-wrapper-register">
                            <Authenticator
                                services={authenticatorServices}
                                initialState={companyOwnerFromId?.cognitoId ? "signIn" : "signUp"}
                                formFields={formFields}
                                components={components}
                                loginMechanisms={["email"]}
                            ></Authenticator>
                        </div>
                    </div>
                </>

            )} isLoading={isLoading} />
    );
};
